import React, { FC, useEffect } from 'react'
import { ReactComponent as MagnifyGlass } from 'assets/illustrations/MagnifyGlassGrey.svg'
import { Button } from 'transfix-ui/components/Button'
import { makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks'
import { RefreshIcon } from 'transfix-icons'

const useRateConfirmationErrorStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100vh',
    margin: '0 auto',
    textAlign: 'center',
  },
  image: {
    width: '107px',
    height: '107px',
    marginBottom: '40px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '5px',
  },
  button: {
    marginTop: '29px',
    display: 'flex',
    flexDirection: 'row',
    width: '110px',
    height: '40px',
    border: `1px solid ${brandColors.skyBlue6}`,
  },
})

interface IRateConfirmationErrorStateProps {
  shipmentId: number
}

export const RateConfirmationErrorState: FC<IRateConfirmationErrorStateProps> = ({
  shipmentId,
}) => {
  const classes = useRateConfirmationErrorStyles()
  const { trackEvent } = useFMSAnalytics()

  const refreshHandler = () => {
    global.location.reload()
  }

  // Mixpanel tracking for rate confirmation error state
  useEffect(() => {
    trackEvent('Rate Con', 'RATE_CONFIRMATION_ERROR_STATE', { shipmentId })
  }, [])

  return (
    <div className={classes.container}>
      <MagnifyGlass className={classes.image} />

      <div className={classes.content}>
        <Typography variant='h3'>Something went wrong.</Typography>
        <Typography variant='body1'>
          Unfortunately we couldn’t find the page you were looking for.
        </Typography>

        <Button
          className={classes.button}
          type='button'
          color='white'
          data-test='refresh-page-button'
          startIcon={<RefreshIcon size='large' />}
          onClick={refreshHandler}>
          &nbsp; Refresh
        </Button>
      </div>
    </div>
  )
}
